import React, { useRef } from 'react';
import propTypes from 'prop-types';
import { TextInput } from '../leaf-components/TextInput';
import { SubmitButton } from '../leaf-components/SubmitButton';

const checkField = (formField, errorMessage) => {
  if (formField.value === '') {
    formField.setCustomValidity(errorMessage);
    return false;
  }

  if (formField.name === 'zip-code' && formField.value.length !== 5) {
    formField.setCustomValidity(errorMessage);
    return false;
  }

  formField.setCustomValidity('');
  return true;
};

const ZipCodeForm = ({ zipCode, setZipCode, onSubmit }) => {
  const zipCodeRef = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    const isZipValid = checkField(zipCodeRef.current, 'Please enter a five digit zip code.');

    if (!isZipValid) {
      zipCodeRef.current.reportValidity();
      return;
    }

    onSubmit(zipCode);
  };

  const handleZipCodeChange = (event) => {
    setZipCode(event.target.value);
    checkField(zipCodeRef.current, 'Please enter a five digit zip code.');
  };

  return (
    <form className="cmp-zip-code-form" onSubmit={handleSubmit}>
      <TextInput
        id="zip-code-form__zip-code"
        name="zip-code"
        label="Zip Code"
        className="cmp-zip-code-form__input"
        placeholder="Enter ZIP Code"
        pattern="^[0-9]{5}?$"
        inputMode="numeric"
        maxLength="5"
        minLength="5"
        autoComplete="postal-code"
        value={zipCode}
        onChange={handleZipCodeChange}
        ref={zipCodeRef}
        data-testid="find-store-input--modal"
      />
      <div className="cmp-zip-code-form__button-wrapper">
        <SubmitButton
          aria-label="Select to search for stores"
          data-testid="find-store-button--modal"
        >
          Find a Store
        </SubmitButton>
      </div>
    </form>
  );
};

ZipCodeForm.propTypes = {
  zipCode: propTypes.string,
  setZipCode: propTypes.func,
  onSubmit: propTypes.func,
};

export { ZipCodeForm };
